module.exports = __webpack_public_path__ + "static/media/deal_ofthe_week.1922d1a3.png";